import { all } from "redux-saga/effects";
import authSaga from "./auth/saga";
import importLogSaga from "./importLog/saga";
import blobSettingSaga from "./blobSetting/saga";
import logSaga from "./log/saga";
import syncLogSaga from "./syncLog/saga";
import entraLogSaga from "./entraLog/saga";
import settingSaga from "./setting/saga";
import entraSyncSaga from "./entraSync/saga";
import gwsSyncSaga from "./gwsSync/saga";
import rosterImportSaga from "./rosterImport/saga";
import oauthKeySaga from "./oauthKey/saga";
import recoveryLogSaga from "./recoveryLog/saga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    importLogSaga(),
    blobSettingSaga(),
    logSaga(),
    syncLogSaga(),
    entraLogSaga(),
    settingSaga(),
    entraSyncSaga(),
    gwsSyncSaga(),
    rosterImportSaga(),
    oauthKeySaga(),
    recoveryLogSaga(),
  ]);
}
